import { render } from "./tw-input-number.vue?vue&type=template&id=b465c390"
import script from "./tw-input-number.vue?vue&type=script&lang=js"
export * from "./tw-input-number.vue?vue&type=script&lang=js"
script.render = render

export default script